var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M30,7.5a30,30,0,0,0,25.981-15,30,30,0,0,0,0-30A30,30,0,0,0,30-52.5a30,30,0,0,0-25.981,15,30,30,0,0,0,0,30A30,30,0,0,0,30,7.5ZM18.75-26.25A3.75,3.75,0,0,1,22.5-22.5a3.75,3.75,0,0,1-3.75,3.75A3.75,3.75,0,0,1,15-22.5,3.75,3.75,0,0,1,18.75-26.25Zm7.5,3.75A3.75,3.75,0,0,1,30-26.25a3.75,3.75,0,0,1,3.75,3.75A3.75,3.75,0,0,1,30-18.75,3.75,3.75,0,0,1,26.25-22.5Zm15-3.75A3.75,3.75,0,0,1,45-22.5a3.75,3.75,0,0,1-3.75,3.75A3.75,3.75,0,0,1,37.5-22.5,3.75,3.75,0,0,1,41.25-26.25Z",
    transform: "translate(0.5 53)",
    fill: "#f79818",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c523431d15c1f830c1fbe0c156e141be.svg";
export { ForwardRef as ReactComponent };